import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface HeaderState {
  bgColor: string;
  bannerImage: string; // active slide image — used by header for blurred bg
}

const initialState: HeaderState = {
  bgColor: '#000000',
  bannerImage: '',
};

const headerBgSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    setHeaderBg(state, action: PayloadAction<string>) {
      state.bgColor = action.payload;
    },
    setHeaderBannerImage(state, action: PayloadAction<string>) {
      state.bannerImage = action.payload;
    },
  },
});

export const { setHeaderBg, setHeaderBannerImage } = headerBgSlice.actions;
export default headerBgSlice.reducer;
